import * as React from "react";

import { DebtorType } from "types";
import { TextField } from "components";

interface PropsType {
  debtor: DebtorType;
  errors: { passwordConfirmation?: string; server?: string[] };
  hidden: boolean;
  onFieldBlur(): void;
  onFieldChange(event: {
    currentTarget: { name: string; value: string };
  }): void;
}

export default function SecurityInfo(props: PropsType): JSX.Element {
  const { debtor, errors, hidden, onFieldBlur, onFieldChange } = props;

  return (
    <section className="security-info" {...{ hidden }}>
      <div className="form--fieldset">
        <div className="content">
          <header>
            <div className="badge">
              <i className="fas fa-shield-alt" />
            </div>

            <h3>Security</h3>
          </header>

          <div className="form--description">
            <p>
              Please enter the password <b>{debtor.firstName}</b> will use to
              log into <b>{debtor.firstName}&apos;s</b> TFS account. Remember,
              passwords need to be at least 8 characters long, contain at least
              one lowercase letter, one uppercase letter, and one number.
            </p>
          </div>

          <div className="body">
            <TextField
              autoComplete="current-password"
              label="Password"
              name="password"
              onBlur={onFieldBlur}
              onChange={onFieldChange}
              placeholder="Password"
              type="password"
            />

            <TextField
              autoComplete="new-password"
              error={errors.passwordConfirmation}
              label="Password Confirmation"
              name="passwordConfirmation"
              onBlur={onFieldBlur}
              onChange={onFieldChange}
              placeholder="Password"
              type="password"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
